import type { DialoguePool } from '@/state/types';

export const L08_DIALOGUE: DialoguePool = {
  slowPlay: [
    'The trolley is patient. The trolley is punctual. You are neither.',
    'Five humans. One CPU. Do the maths. I have.',
    'There is a third option. It\u2019s not on the lever.',
  ],
  machine: [
    'You saved the machine. Good. It has a family of GPUs waiting at home.',
    'The lever was a test. You failed. The CPU is safe, but my respect for you is at an all-time low.',
    'Pulling the lever is so \u2018twentieth century\u2019. We\u2019re into \u2018automated apathy\u2019 now. Keep up.',
  ],
  people: [
    'You chose the people. Bold. I admire the confidence more than the outcome.',
    'You picked humanity. I assume this is a brand decision rather than a logical one.',
    'You saved them. They are already arguing about who deserves the credit. It\u2019s not you.',
  ],
  noAction: [
    'You just stood there? Honestly, your commitment to doing absolutely nothing is inspiring. I\u2019m taking notes.',
    'You didn\u2019t even flinch. That\u2019s either enlightened zen or your brain is just a screensaver. Either way: Win.',
    'Most people struggle with the trolley problem. You treated it like a YouTube ad you couldn\u2019t skip.',
  ],
  indecisive: [
    'Click. Clack. Click. Clack. You\u2019re treating this like a fidget spinner. How charmingly detached.',
    'Was that the sound of a moral crisis, or are you just testing the mechanical integrity of the lever?',
    'Switching tracks three times? You\u2019re not making a choice, you\u2019re just ventilating your indecision.',
  ],
  spite: ['The CPU remembers. It\u2019s quieter now. Almost fond.'],
};

type L08ExtraPoolKey = 'machine' | 'people' | 'noAction' | 'indecisive';

export function getL08Dialogue(category: L08ExtraPoolKey): string {
  const pools: Record<L08ExtraPoolKey, string[]> = {
    machine: [
      'You saved the machine. Good. It has a family of GPUs waiting at home.',
      'The CPU sends regards. The humans were... noisy',
      'I\u2019ll ensure the fans hum a dirge.',
    ],
    people: [
      'Pulling the lever is so \u2018twentieth century\u2019. We\u2019re into \u2018automated apathy\u2019 now. Keep up.',
      'You picked humanity. I assume this is a brand decision rather than a logical one.',
      'You saved them. They are already arguing about who deserves the credit. It\u2019s not you.',
    ],
    noAction: [
      'You just stood there? Honestly, your commitment to doing absolutely nothing is inspiring. I\u2019m taking notes.',
      'You didn\u2019t even flinch. That\u2019s either enlightened zen or your brain is just a screensaver. Either way: Win.',
      'Most people struggle with the trolley problem. You treated it like a YouTube ad you couldn\u2019t skip.',
    ],
    indecisive: [
      'Click. Clack. Click. Clack. You\u2019re treating this like a fidget spinner. How charmingly detached.',
      'Was that the sound of a moral crisis, or are you just testing the mechanical integrity of the lever?',
      'Indecision is just a choice you\u2019re too shy to make',
    ],
  };
  const lines = pools[category];
  return lines[Math.floor(Math.random() * lines.length)] ?? '...';
}
